/* Kahvikoneet.fi – oppaiden yhteinen JS (kk-opas.js)
   Yleiset toiminnot: lukuedistymä, esiin ilmestyminen, välilehdet,
   Tosi vai taru -peli ja jakopainikkeet. Oppaskohtainen logiikka on
   kunkin oppaan omassa osiossa. */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call(c.querySelectorAll(s)); };

  function progress(root) {
    var bar = root.querySelector('.kl-progress span');
    if (!bar) return;
    var ticking = false;
    function run() {
      var r = root.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.width = (p * 100).toFixed(2) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(run); ticking = true; }
    }, { passive: true });
    run();
  }

  function reveal(root) {
    var els = $$('.kl-reveal', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('kl-is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kl-is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  function tabs(root) {
    $$('[data-kl-tabs]', root).forEach(function (list) {
      var ts = $$('[role="tab"]', list);
      function select(tab, focus) {
        ts.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        list.dispatchEvent(new CustomEvent('kl:tab', { detail: { tab: tab } }));
        if (focus) tab.focus();
      }
      ts.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = ts[(i + 1) % ts.length];
          if (e.key === 'ArrowLeft') n = ts[(i - 1 + ts.length) % ts.length];
          if (e.key === 'Home') n = ts[0];
          if (e.key === 'End') n = ts[ts.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      select(ts.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || ts[0]);
    });
  }

  function game(root) {
    $$('[data-kl-game]', root).forEach(function (g) {
      var claims = $$('.kl-claim', g);
      var scoreEl = g.querySelector('.kl-game__score');
      var right = 0, answered = 0;
      claims.forEach(function (c) {
        var ans = c.querySelector('.kl-claim__a');
        if (ans) ans.hidden = true;
        $$('button', c).forEach(function (b) {
          b.addEventListener('click', function () {
            if (c.getAttribute('data-done')) return;
            c.setAttribute('data-done', '1');
            var ok = b.getAttribute('data-v') === c.getAttribute('data-answer');
            answered++; if (ok) right++;
            $$('button', c).forEach(function (x) {
              x.disabled = true;
              if (x.getAttribute('data-v') === c.getAttribute('data-answer')) x.classList.add('kl-right');
              else if (x === b) x.classList.add('kl-wrong');
            });
            if (ans) ans.hidden = false;
            var msg = right + ' / ' + claims.length + ' oikein';
            if (answered === claims.length) {
              msg += right === claims.length ? ' · Täydet pisteet!' : (right >= claims.length - 2 ? ' · Hyvä baristan vaisto!' : ' · Nyt tiedät enemmän!');
            }
            if (scoreEl) scoreEl.textContent = msg;
          });
        });
      });
    });
  }

  function share(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-kl-share]') : null;
      if (!b || !root.contains(b)) return;
      var url = location.href.split('#')[0] + (b.getAttribute('data-kl-share-hash') || '');
      var text = b.getAttribute('data-kl-share') || document.title;
      var toast = b.parentNode.querySelector('.kl-toast');
      if (navigator.share) {
        navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () { if (toast) toast.textContent = 'Linkki kopioitu leikepöydälle!'; });
      } else if (toast) { toast.textContent = url; }
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-kl-init')) return;
    root.setAttribute('data-kl-init', '1');
    root.classList.add('kl-js');
    progress(root); reveal(root); tabs(root); game(root); share(root);
  }

  function initAll() { $$('[data-kl]', document).forEach(init); }
  window.KKOpas = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-kl]'); if (r) init(r);
  });
})();
